import * as React from 'react';
import { GridCustomFilterCellProps } from '@progress/kendo-react-grid';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import {
  Button,
  DropDownButton,
  DropDownButtonItemClickEvent,
} from '@progress/kendo-react-buttons';
import { State } from '@progress/kendo-data-query';
import { DatePicker } from '@progress/kendo-react-dateinputs';
import { DatePickerChangeEvent } from '@progress/kendo-react-dateinputs';
import { fomatDateToLocaleISODate, convertStringTodate } from '../utils/utils';
import { GetString } from './StringResourceManager';
import { operators } from '../utils/constants';
import { filterClearIcon, filterIcon } from '@progress/kendo-svg-icons';
import { HeaderTdElement } from '@progress/kendo-react-data-tools';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    spaceBetween: {
      marginInline: 3,
    },
  })
);

export interface CustomDateFilterCellProps {
  fieldName?: string;
  dataState: State;
  gridFilterCellProps: GridCustomFilterCellProps;
}

export const CustomDateFilterCell = (props: CustomDateFilterCellProps) => {
  const classes = useStyles();

  const [value, setValue] = React.useState<Date | null>();

  const [selectedOperator, setSelectedOperator] =
    React.useState<string>('contains');

  React.useEffect(() => {
    props.dataState?.filter?.filters.map((e: any) => {
      if (e?.field === props.fieldName) {
        if (e.value != '') {
          setValue(convertStringTodate(e?.value));
          setSelectedOperator(e.operator);
        }
      }
    });
  }, [props.dataState]);

  const dateFilterOnChange = (event: DatePickerChangeEvent) => {
    const newValue = event.value;
    const hasValidDate = newValue && !isNaN(new Date(newValue).getTime());

    setValue(hasValidDate ? newValue : null);
    props.gridFilterCellProps.onChange({
      value: hasValidDate ? fomatDateToLocaleISODate(event.value) : '',
      operator: hasValidDate ? selectedOperator : '',
      syntheticEvent: event.syntheticEvent,
    });
  };

  const onClearButtonClick = (event: React.MouseEvent<HTMLElement>) => {
    if (event) event.preventDefault();
    props.gridFilterCellProps.onChange({
      value: '',
      operator: '',
      syntheticEvent: event,
    });
    setValue(null);
    setSelectedOperator('contains');
  };

  var textOperator: string[] = [];

  for (let i = 0; i < operators.length; i++) {
    textOperator.push(GetString(operators[i].text));
  }

  const onChooseOperatorClicked = (event: DropDownButtonItemClickEvent) => {
    if (!value) return;

    for (let i = 0; i < textOperator.length; i++) {
      if (textOperator[i] === event.item) {
        props.gridFilterCellProps.onChange({
          value: fomatDateToLocaleISODate(value),
          operator: operators[i].operator,
          syntheticEvent: event.syntheticEvent,
        });
      }
    }
  };

  return (
    <HeaderTdElement
      columnId={props.gridFilterCellProps.thProps?.columnId || ''}
      {...props.gridFilterCellProps.thProps}
    >
      <div className="k-filtercell">
        <DatePicker
          format="MM/dd/yyyy"
          onChange={dateFilterOnChange}
          value={value}
        />
        <div className={classes.spaceBetween} />
        <DropDownButton
          svgIcon={filterIcon}
          title="Choose operator"
          items={operators.map(operators => GetString(operators.text))}
          onItemClick={onChooseOperatorClicked}
        />
        <div className={classes.spaceBetween} />
        <Button
          title="Clear"
          onClick={onClearButtonClick}
          svgIcon={filterClearIcon}
          disabled={!value}
        ></Button>
      </div>
    </HeaderTdElement>
  );
};
